import { render, staticRenderFns } from "./PopupSmartDislikes.vue?vue&type=template&id=356a1866"
import script from "./PopupSmartDislikes.vue?vue&type=script&lang=js"
export * from "./PopupSmartDislikes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports